import { defineStore, acceptHMRUpdate } from 'pinia'
import { computed } from 'vue'
import { useAccountQuery } from 'src/composables/account/query/useAccountQuery'

// `useAccountStore` is the canonical session/tenant store per the end-state
// contract: rename to `useSessionStore` was considered in Phase 4 and rejected
// (the contract keeps `useAccountStore` as the surviving public API).
export const useAccountStore = defineStore('account', () => {
  const accountQuery = useAccountQuery()

  // Tenant id from GET /me — consumed by http.service.js for `account_id` injection.
  const accountId = accountQuery.accountId
  const accountData = accountQuery.accountData

  const displayName = computed(() => {
    const data = accountData.value
    if (!data) return ''
    if (data.firstName && data.lastName) {
      return `${data.firstName} ${data.lastName}`
    }
    return data.firstName || data.lastName || ''
  })

  return {
    accountId,
    accountData,
    displayName,
    isLoading: accountQuery.isLoading,
    isRefetching: accountQuery.isRefetching,
    error: accountQuery.error,
    refetch: accountQuery.refetch,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAccountStore, import.meta.hot))
}
